module.exports = {"bar":{"settings":"SETTINGS","dashboard":"DASHBOARD"},"setup":{"time_unit":10}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 51
// module chunks = 0